export default {
    getSessionToken: state => state.sessionToken,
    getSessionDetails: state => state.sessionDetails,
    getTestToken: state => state.testToken,
    getGalleryImages: state => state.gallery,
    getTemplateFormat: state => state.templateFormat,
    getProject: state => state.project,
    getActivePageId: state => state.project.pages.find(page => page.content.isActive === true).content.id,
    getActivePage: state => state.project.pages.find(page => page.content.isActive === true),
    getActivePageIndex: state => state.project.pages.findIndex(page => page.content.isActive === true),
    getCurrentPage: state => state.currentPage,
    getCurrentTab: state => state.currentTab,
    getCurrentPageIndex: state => state.currentPageIndex,
    getPageWidth: state => state.pageWidth,
    getPageHeight: state => state.pageHeight,
    getPageBleed: state => state.pageBleed,
    getMoveableElements: state => state.moveableElements,
    isGalleryModalOpen: state => state.galleryModalOpen,
    getFonts: state => state.fonts,
    getActiveElement: state => state.activeElement,
    activeElement: state => {
        return state.project.pages[state.currentPageIndex].content.elements.find(element => element.isActive === true)
    },
    getEmptyPhotoCells: state => {
        return state.project.pages[state.currentPageIndex].content.elements.filter(element => element.type === 'PHOTO_CELL_ELEMENT').filter(photoCell => photoCell.maskImg.src === null)
    },
    getZIndex: state => {
        return state.project.pages[state.currentPageIndex].content.zIndex
    },
    getPages: state => {
        return state.project.pages.sort((a, b) => parseFloat(a.number) - parseFloat(b.number));
    },
    getPageWebSize: state => {
        return state.webPageSize;
    },
    getPageSize: state => {
        return state.pageSize;
    },
    getPageTransition: state => {
        return state.pageTransition;
    },
    getPlaceholders: state => {
        return state.placeholders;
    },
    getPlaceholderUserInputs: state => {
        return state.placeholderUserInputs;
    },
    getHiddenTabs: state => {
        return state.hiddenTabs;
    },
    getLastUsedColors: state => {
        return state.lastUsedColors;
    },
    getCustomFonts: state => {
        return state.sessionDetails.customFonts;
    },
    getAllElements: (state, getters) => {
        let allElements = [];
        getters.getPages.forEach(page => {
            allElements = [...allElements, ...page.content.elements]
        });
        return allElements;
    },
    areElementsLoaded: (state) => {
        return state.allElementsLoaded;
    },
    areElementsChanging: (state) => {
        return state.elementsChanging;
    }
}